import { ADD_NEW_LOCATION, UPDATE_LOCATION, DELETE_LOCATION, FETCH_LOCATIONS_BY_USER, START_LOADING, END_LOADING } from '../actions/constants'

const locations = (state = { isLoading: true, locations: [] }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true }
    case END_LOADING:
      return { ...state, isLoading: false }
    case FETCH_LOCATIONS_BY_USER:
      return { ...state, locations: action.payload }
    case ADD_NEW_LOCATION:
      return { ...state, locations: [...state.locations, action.payload] }
    case UPDATE_LOCATION:
      return { ...state, locations: state.locations.map((l) => (l._id === action.payload._id ? action.payload : l)) }
    case DELETE_LOCATION:
      return { ...state, locations: state.locations.filter((l) => l._id !== action.payload) }
    default:
      return state
  }
}

export default locations
